import {
  scrollTo,
  setDocumentTitle,
  replaceInnerHtml,
  getLazyLoadInstance,
  getElementOffsetTop,
  dispatchCustomEventGlobally,
} from 'www/utils'
import { POPUP_MAP_EVENTS, SCROLL_TO_OPTIONS } from 'www/constants'
import useCommonStore from 'www/vue_components/common/TheFilters/doctors/stores/useCommonStore'
import type { ApiDoctorListResponseGet } from 'www/vue_components/common/TheFilters/doctors/api/apiDoctorList.types'

const lazyLoadInstance = window.MOBILE_VERSION ? getLazyLoadInstance() : null

function populatePageWithNewData(data: ApiDoctorListResponseGet) {
  const commonStore = useCommonStore()

  setDocumentTitle(data.title)
  replaceInnerHtml(commonStore.domNodes.head, data.head)
  replaceInnerHtml(commonStore.domNodes.breadcrumbs, data.bread)
  replaceInnerHtml(commonStore.domNodes.pagination, data.paginator)
  replaceInnerHtml(commonStore.domNodes.list, data.appointments_page)
  replaceInnerHtml(commonStore.domNodes.doctorsListInfo, data.information)

  if (!window.MOBILE_VERSION && commonStore.domNodes.titleSpeciality) {
    replaceInnerHtml(commonStore.domNodes.titleSpeciality, data.names_rod)
  }

  if (data.lpu_ad) {
    replaceInnerHtml(commonStore.domNodes.lpuAd, data.lpu_ad)
    dispatchCustomEventGlobally('executeLpuAdScript')
  }

  const scrollTarget = document.querySelector(commonStore.domNodes.scrollTarget)

  if (scrollTarget) {
    scrollTo(
      getElementOffsetTop(scrollTarget),
      SCROLL_TO_OPTIONS,
    )
  }

  document.dispatchEvent(new Event('content-replace'))
  document.dispatchEvent(new Event('refreshInit'))
  document.dispatchEvent(new Event('initSlider'))
  dispatchCustomEventGlobally('mountDoctorPriceBlock')

  document.dispatchEvent(new Event('mountLpuLoyaltyProgram'))

  if (window.MOBILE_VERSION) {
    dispatchCustomEventGlobally(POPUP_MAP_EVENTS.mounted)

    lazyLoadInstance?.update()
  }
}

export default populatePageWithNewData
